import { alphaMutationRejected } from "../alpha-mutation";
import { useEffect, useRef, useState } from "react";
import { api } from "../api";
import { ErrorState, Loading } from "../ui/State";
export function AutomationSimulationAlpha() {
  const [model, setModel] = useState<any>(),
    [error, setError] = useState<unknown>(),
    [busy, setBusy] = useState(false),
    pending = useRef<{ url: string; body: any } | null>(null);
  const root = "/api/alpha/rule-simulations",
    load = () => api(root).then(setModel);
  useEffect(() => {
    void load().catch(setError);
  }, []);
  async function save(url: string, body: any) {
    pending.current ??= {
      url,
      body: { ...body, idempotencyKey: crypto.randomUUID() },
    };
    setBusy(true);
    try {
      await api(pending.current.url, {
        method: "POST",
        body: JSON.stringify(pending.current.body),
      });
      pending.current = null;
      setError(undefined);
      await load();
    } catch (e) {
      if (alphaMutationRejected(e)) pending.current = null;
      setError(e);
    } finally {
      setBusy(false);
    }
  }
  return (
    <>
      <h1>Automation preview</h1>
      <p>
        Preview the governance reminder window. Simulations create no Actions or
        messages. Approval changes the existing rule configuration; its enabled
        state is retained.
      </p>
      {Boolean(error) && <ErrorState error={error} />}{" "}
      {pending.current && !busy && (
        <button onClick={() => void save("", {})}>Retry the same save</button>
      )}
      <form
        className="form"
        onSubmit={(e) => {
          e.preventDefault();
          const f = new FormData(e.currentTarget);
          void save(root, {
            lookAheadDays: Number(f.get("days")),
            reason: f.get("reason"),
          });
        }}
      >
        <fieldset disabled={busy || !!pending.current}>
          <legend>Simulate a reminder window</legend>
          <label>
            Days ahead
            <input
              type="number"
              name="days"
              min={1}
              max={365}
              defaultValue={30}
              required
            />
          </label>
          <label>
            Why change this rule?
            <textarea name="reason" required minLength={10} maxLength={2000} />
          </label>
          <button>Run preview</button>
        </fieldset>
      </form>
      {!model ? (
        <Loading />
      ) : (
        model.runs.map((r: any) => (
          <section className="panel" key={r.id}>
            <h2>
              {r.input.configuration.lookAheadDays} days · {r.status}
            </h2>
            <p>{r.output.basis}</p>
            <p>
              {r.output.current.filter((x: any) => x.proposedWouldRun).length}{" "}
              current obligations selected · {r.output.historical.length}{" "}
              retained historical inputs replayed
            </p>
            {r.output.truncated && (
              <p>Incomplete preview. Approval is unavailable.</p>
            )}
            <ul>
              {r.output.current.map((x: any) => (
                <li key={x.id}>
                  {x.title} · Current:{" "}
                  {x.currentWouldRun ? "selected" : "not selected"} · Proposed:{" "}
                  {x.proposedWouldRun ? "selected" : "not selected"}
                </li>
              ))}
            </ul>
            {r.status === "Awaiting approval" && !r.output.truncated && (
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  void save(root + "/" + r.id + "/approve", {
                    reason: new FormData(e.currentTarget).get("reason"),
                  });
                }}
              >
                <fieldset disabled={busy || !!pending.current}>
                  <legend>Approve this configuration</legend>
                  <label>
                    Review rationale
                    <textarea name="reason" required minLength={10} />
                  </label>
                  <button>Approve rule configuration</button>
                </fieldset>
              </form>
            )}
          </section>
        ))
      )}
    </>
  );
}
